import _ from 'underscore';

function MergeAttributionsCtrl($scope, alertService, sdkUtils, attributionSourceService, $q, organizationService, ERROR_MESSAGES) {
  if (!$scope.attributions || !$scope.attributions.length) throw new Error('merge-attributions directive - attributions is required on scope');
  if ($scope.attributions.length < 2) throw new Error('merge-attributions directive - must have at least 2 attributions for merge');

  const currentUserOrganization = organizationService.getCurrentOrganization();

  if (!currentUserOrganization) {
    alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION);
    return;
  }

  _initScope();

  function _initScope() {
    $scope.mergeAttributions = _mergeAttributions;

    $scope.selectedAttributionProperties = {};
  }

  function _mergeAttributions($event) {
    if ($event) $event.preventDefault();

    const toAttributionId = $scope.selectedAttributionProperties.id;

    const fromAttributionsIds = _.reject(_.pluck($scope.attributions, 'id'), id => {
      return id === toAttributionId;
    });

    $scope.mergingAttributions = true;

    const data = {
      fromAttributionSourceIds: fromAttributionsIds,
      toAttributionSourceId: toAttributionId,
      name: $scope.selectedAttributionProperties.name,
      type: 'MERGE'
    };

    attributionSourceService.performActionByOrganizationId(currentUserOrganization.id, data)
      .then(updatedAttributionSource => {
        if ($scope.onMerged) {
          $scope.onMerged({
            attribution: updatedAttributionSource,
            deletedAttributionIds: fromAttributionsIds
          });
        }
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      })
      .finally(() => {
        $scope.mergingAttributions = false;
      });
  }
}

MergeAttributionsCtrl.$inject = [
  '$scope',
  'alertService',
  'jsSdk.utils',
  'jsSdk.attributionSource',
  '$q',
  'organizationService',
  'ERROR_MESSAGES'
];

export default MergeAttributionsCtrl;



// WEBPACK FOOTER //
// ./src/directives/mergeAttributions/controller.js